<template>
    <div class="ordered-product card">
        <div class="card-body">
            <div class="ordered-product-header">
                <div class="ordered-product-ordered">
                    {{ nbOrdered }}
                </div>

                <div class="ordered-product-name">
                    {{ name }}
                </div>
            </div>

            <div class="ordered-product-inputs">
                Commande automatique, pas de préparation
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OrderedProduct',

        props: {
            order: {
                type: Object,
                required: true,
            },
            sku: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            nbOrdered: {
                type: Number,
                required: true,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .ordered-product {
        .card-body {
            display: flex;
            flex-direction: column;
        }

        .ordered-product-header {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: baseline;
            font-size: 1.6rem;
            margin-bottom: 16px;

            .ordered-product-ordered {
                border: 2px solid black;
                border-radius: 3px;
                min-height: 48px;
                min-width: 48px;
                line-height: 48px;
                text-align: center;
                flex-shrink: 0;
                padding: 0 7px;
            }

            .ordered-product-name {
                text-align: center;
                flex-shrink: 1;
                margin: 0 7px;
            }
        }

        .ordered-product-inputs {
            color: #cf2a27;
            font-weight: bold;
            text-align: center;
            flex-grow: 2;
        }
    }
</style>
